<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="500"
    :loading="loading"
    okText="审核成功"
    @close="onClose"
    @ok="onSubmitFun"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form v-if="user.name">
        <e-show :labelCol="6" title="姓名" :value="user.name" />
        <e-show :labelCol="6" title="性别">{{ $store.state.app.sexes[user.sex].label }}</e-show>
        <e-show :labelCol="6" title="手机号" :value="user.mobile" />
        <e-show :labelCol="6" title="身份证" :value="user.idCard" />
        <e-show :labelCol="6" title="身份证正面">
          <img style="width: 100%" :src="user.idCardFront" alt="">
        </e-show>
        <e-show :labelCol="6" title="身份证反面">
          <img style="width: 100%" :src="user.idCardBack" alt="">
        </e-show>
        <e-show :labelCol="6" title="营业执照">
          <img style="width: 100%" :src="user.yingyezhizhao" alt="">
        </e-show>
      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref } from 'vue'
import form from '@/mixins/form'
import { UserClass } from '@/apis/user'

const api = new UserClass()
export default defineComponent({
  components: {},
  mixins: [form],
  emits: ['ok'],
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const title = ref('')
    const user = ref({})

    const onClose = () => {
      loading.value = false
      visible.value = false
    }

    return {
      title,
      visible,
      loading,
      user,

      onClose
    }
  },

  methods: {
    open (formData) {
      this.user = formData
      this.title = '审核入驻'
      this.visible = true
    },

    onSubmitFun () {
      this.loading = true
      api.setEnter(this.user.id).then(() => {
        this.loading = false
        this.$message.success('审核成功')
        this.$emit('ok')
        this.onClose()
      })
    }
  }
})
</script>
